import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { FedopsWixCodeSdkSiteConfig } from '../types'

const fedopsWixCodeSdkSiteConfig: SiteConfigFn<FedopsWixCodeSdkSiteConfig> = ({ api }) => {
	const shouldLoadSiteConfig = api.features.isActive('platform')

	const isWixSite = api.rendererModel.getSiteInfo()?.documentType === 'WixSite'
	const metaSiteId = api.rendererModel.getMetaSiteId()
	const fedopsAllowedSites = api.rendererModel.getFedopsAllowedSites() ?? []
	const shouldReportFedops = fedopsAllowedSites.includes(metaSiteId)

	return {
		shouldLoadSiteFeature: false,
		shouldLoadSiteConfig,
		siteConfig: shouldLoadSiteConfig ? { isWixSite, shouldReportFedops } : null,
	}
}

const name = 'fedopsWixCodeSdk'

export const config = { site: fedopsWixCodeSdkSiteConfig, reactNativeSite: fedopsWixCodeSdkSiteConfig, name }
